import React from "react";

const Button = ({ children, onClick, type, className, disabled = false }) => {
  return (
    <button
      type={type}
      className={`${className} ${disabled ? 'bg-gray-1' : ''}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;
